<template>
  <svg fill="none" height="24" viewBox="0 0 28 24" width="28" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.0746 0C21.4565 0 27.1643 8.49354 24.003 16.2562L22.65 19.5741C22.5909 19.7188 22.5802 19.8788 22.6194 20.0301C22.6586 20.1814 22.7456 20.316 22.8675 20.4138L25.7287 22.7094C25.8458 22.8033 25.9309 22.9314 25.9721 23.0758C26.0134 23.2202 26.0088 23.3738 25.9589 23.5155C25.9091 23.6572 25.8165 23.7799 25.694 23.8666C25.5714 23.9534 25.4249 24 25.2748 24H13.9346C12.2716 24.0002 10.6248 23.6728 9.08832 23.0365C7.55184 22.4002 6.15575 21.4675 4.97975 20.2917C3.80375 19.1158 2.8709 17.7198 2.23444 16.1834C1.59799 14.647 1.27041 13.0003 1.27041 11.3373C1.27041 5.07553 6.34594 0 12.6077 0H13.0746Z" fill="#80BC5E"/>
  </svg>
</template>

<script>
export default { name: "TalkIcon" };
</script>
